import { InspectionCase } from './inspection-case.dto';
import {
  InspectionFlowPressureCase,
  InspectionFlowPressureCaseDto
} from './inspection-flow-pressure-case.dto';

export class InspectionWaterFlowCaseDto extends InspectionCase {
  flowAndPressureClosedTap?: InspectionFlowPressureCaseDto;
  flowAndPressure100?: InspectionFlowPressureCaseDto;
  flowAndPressure150?: InspectionFlowPressureCaseDto;
}

export class InspectionWaterFlowCase extends InspectionWaterFlowCaseDto {
  constructor(
    data: InspectionWaterFlowCaseDto = {
      isApplicable: false,
      isPassed: true,
      title: 'תוצאות בדיקת המשאבה'
    }
  ) {
    super(data);

    this.flowAndPressureClosedTap = new InspectionFlowPressureCase({
      ...data.flowAndPressureClosedTap,
      // title: `ספיקה ולחצים ללא הזרמת מים (ברז סגור)`
      title: 'ללא זרימה'
    });
    this.flowAndPressure100 = new InspectionFlowPressureCase({
      ...data.flowAndPressure100,
      // title: `ספיקה ולחצים ב-100%`
      title: '2000gpm-100%'
    });
    this.flowAndPressure150 = new InspectionFlowPressureCase({
      ...data.flowAndPressure150,
      // title: `ספיקה ולחצים ב-150%`
      title: '3000gpm-150%'
    });
  }
}
